"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextWrapper = exports.Content = void 0;
const styled_components_1 = __importStar(require("styled-components"));
// eslint-disable-next-line import/prefer-default-export
exports.Content = styled_components_1.default.div `
  ${({ theme }) => (0, styled_components_1.css) `
    width: 100%;
    max-width: 600px;
    border-radius: ${theme.border.radius.default * 2}px;
    background-color: ${theme.palette.background.default};
    box-shadow: inset 0 2px 3px 0 #ffffff, 0 4px 10px 0 rgba(21, 19, 56, 0.07),
      0 20px 50px 0 rgba(7, 7, 12, 0.13);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    padding: ${theme.spacing.unit * 2}px;
    padding-bottom: 10px;
    box-shadow: none;
    border-radius: 0;

        & > button {
      width: 100%;
      max-width: unset;
      padding: 0;
      height: 51px;
    }
  `}
`;
exports.TextWrapper = styled_components_1.default.div `
  ${({ theme }) => (0, styled_components_1.css) `
    padding: ${theme.spacing.unit * 4}px;
  `}
`;
//# sourceMappingURL=styled.js.map